import { Box, Theme } from "@mui/material";
import { NavbarIcon } from "../../atoms/navbar/Icon";
import { DefaultBadge, StatusBadge } from "../../atoms/StatusBadge";
import { openSnackbar } from "../../context/SnackbarContext";
import { BaseFilterOptions, BaseFilters, Deployment, FilterOption } from "../../models/types";
import { IColumnVisibility } from "../../molecules/ColumnVisibility";
import { TableTextWithEllipsis } from "../../molecules/TableTextWithEllipsis";
import { getBaseDeploymentUrl } from "../DeploymentHelper";
import { defaultDateDisplay } from "../UIHelper";

export const deploymentsListFilterOptions: FilterOption<BaseFilters>[] = [
  { label: "ID", value: "id" },
  ...BaseFilterOptions,
];

export const deploymentsListColumnsVisibility = (
  compact: boolean,
  theme: Theme
): IColumnVisibility<Deployment>[] => {
  return [
    ...(!compact
      ? ([
          {
            field: "name",
            headerName: "Name",
            visible: true,
            columnMinWidth: 120,
            columnMaxWidth: 300,
            renderer: (d) => <TableTextWithEllipsis value={d.name} />,
          },
          {
            field: "runnable",
            headerName: "Runnable",
            visible: true,
            columnMinWidth: 120,
            columnMaxWidth: 300,
            renderer: (d) => (
              <TableTextWithEllipsis value={`${d.runnable_name.name}-${d.runnable_name.version}`} />
            ),
          },
          {
            field: "id",
            headerName: "Endpoint",
            visible: true,
            columnMinWidth: 120,
            renderer: (d) => (
              <Box
                display="flex"
                justifyContent="flex-start"
                width="100%"
                alignItems="center"
                gap="16px"
                onClick={(e) => {
                  e.stopPropagation();
                  navigator.clipboard.writeText(`${getBaseDeploymentUrl()}${d.id}`);
                  openSnackbar("Endpoint copied successfully", "success");
                }}
              >
                <TableTextWithEllipsis
                  fullWidth={false}
                  value={`${getBaseDeploymentUrl()}${d.id}`}
                />
                <NavbarIcon
                  color={theme.palette.custom.hyperlink}
                  variant="copy"
                  sx={{ height: "18px", width: "18px" }}
                />
              </Box>
            ),
          },
          {
            field: "created_at",
            headerName: "Deployed On",
            visible: true,
            columnMinWidth: 120,
            columnMaxWidth: 120,
            renderer: (d) => (
              <TableTextWithEllipsis value={defaultDateDisplay(d.created_on) ?? ""} />
            ),
          },
          {
            field: "status",
            headerName: "Status",
            visible: true,
            columnMinWidth: 100,
            columnMaxWidth: 100,
            renderer: (d) => (
              <StatusBadge status={d.status.toUpperCase() as "ACTIVE" | "INACTIVE"} />
            ),
          },
        ] as IColumnVisibility<Deployment>[])
      : ([
          {
            field: "created_at",
            headerName: "Deployed On",
            visible: true,
            columnMinWidth: 120,
            columnMaxWidth: 120,
            renderer: (d) => (
              <TableTextWithEllipsis value={defaultDateDisplay(d.created_on) ?? ""} />
            ),
          },
          {
            field: "type",
            headerName: "Type",
            visible: true,
            columnMinWidth: 120,
            columnMaxWidth: 150,
            renderer: (d) => <DefaultBadge value={d.type} />,
          },
        ] as IColumnVisibility<Deployment>[])),
  ];
};
